var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n:-ms-input-placeholder{\n  color: #aaaaaa;\n}\n::placeholder{\n  color: #aaaaaa;\n}\n.spanish_text{\n  margin-bottom: 0px;\n}\n\n.english_label{\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.question_spanish{\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.logo-group{\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  position: relative;\n  margin: auto;\n}\n.score-item{\n  float: left;\n  color: black !important;\n  min-width: 0px;\n  max-width: 10%;\n  border: 1px solid black;\n  border-width: 1px 0px 1px 0px;\n}\n.logo-group-div{\n  width: 33.33%;\n  max-width: 33.33%;\n  margin: 0 auto;\n  vertical-align: middle;\n}\n.logo-group-div:hover{\n  border: 2px solid rgba(52,168,235,.5)\n}\n.inputHalf{\n  width: 50%;\n  max-width: 50%;\n  float: left;\n  padding: 5px 10px;\n}\n.inputFull{\n  width: 100%;\n  max-width: 100%;\n  float: left;\n  padding: 5px 10px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _UiIconButton = require('../material/UiIconButton.vue');

var _UiIconButton2 = _interopRequireDefault(_UiIconButton);

var _UiRadioGroup = require('../material/UiRadioGroup.vue');

var _UiRadioGroup2 = _interopRequireDefault(_UiRadioGroup);

var _UiSelect = require('../material/UiSelect.vue');

var _UiSelect2 = _interopRequireDefault(_UiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Client',
  mixins: [_globals2.default],
  components: {
    UiRadioGroup: _UiRadioGroup2.default,
    UiIconButton: _UiIconButton2.default,
    UiSelect: _UiSelect2.default
  },
  data: function data() {
    return {
      date_regex: RegExp("^[0-3]{0,1}[0-9]{1}/[0-1]{0,1}[0-9]{1}/[1-2]{1}[0,1,2,9]{1}[0-9]{2}$"),
      options_comentario: [{ value: '1', text: 'Felicitaciones (Compliments)' }, { value: '2', text: 'Sugerencia (Suggestion)' }, { value: '3', text: 'Queja (Complaint)' }],
      options_nacionalidad: [{ value: 'Peruano', text: 'Nacional (National)' }, { value: 'Extranjero', text: 'Extranjero (Tourist)' }],
      options_primera_vez: [{ value: 'Sí', text: 'Sí (Yes)' }, { value: 'No', text: 'No (No)' }],
      options_origen: [],
      locals: [],
      selectableLocals: [],
      pickedRestaurant: null,
      pickedLocal: null,
      first_name: '',
      last_name: '',
      email: '',
      comment: '',
      phone_number: '',
      distrito: '',
      fecha_de_cumpleanos: '',
      selectedMessage: null,
      selectedNacionalidad: '',
      selectedPrimeraVez: '',
      selectedOrigen: '',
      selectedOrigenRadio: '',
      selectedOrigenOther: '',
      modalError: false,
      modalFinish: false,
      infoSubmitted: false,
      encuestaSubmitted: false,
      restaurantPicked: false,
      disabledSend: false,
      disabledSubmit: true,
      flag1: { opt1: false, opt2: false, opt3: false, opt4: false },
      flag2: { opt1: false, opt2: false, opt3: false, opt4: false },
      flag3: { opt1: false, opt2: false, opt3: false, opt4: false },
      flag4: { opt1: false, opt2: false, opt3: false, opt4: false },
      flag5: { opt1: false, opt2: false, opt3: false, opt4: false },
      flag6: { opt1: false, opt2: false, opt3: false, opt4: false, opt5: false,
        opt6: false, opt7: false, opt8: false, opt9: false, opt10: false },
      itemSelected: [],
      flagComment: false,
      flagTypeMessage: false,
      flagCumpleanos: true,
      ignoreSubmit: false
    };
  },

  watch: {
    selectedNacionalidad: function selectedNacionalidad(val, old) {
      if (val) {
        if (this.flagTypeMessage && (this.flagComment || this.selectedMessage != 3) && this.selectedOrigen && this.selectedPrimeraVez) {
          this.disabledSend = true;
        } else {
          this.disabledSend = false;
        }
      } else {
        this.disabledSend = false;
      }
    },
    selectedPrimeraVez: function selectedPrimeraVez(val, old) {
      if (val) {
        if (this.flagTypeMessage && (this.flagComment || this.selectedMessage != 3) && this.selectedOrigen && this.selectedNacionalidad) {
          this.disabledSend = true;
        } else {
          this.disabledSend = false;
        }
      } else {
        this.disabledSend = false;
      }
    },
    selectedOrigen: function selectedOrigen(val, old) {
      if (val) {
        if (this.flagTypeMessage && (this.flagComment || this.selectedMessage != 3) && this.selectedPrimeraVez && this.selectedNacionalidad) {
          this.disabledSend = true;
        } else {
          this.disabledSend = false;
        }
      } else {
        this.disabledSend = false;
      }
    },
    comment: function comment(val, old) {
      if (val) {
        this.flagComment = true;
        if (this.flagTypeMessage && this.selectedNacionalidad && this.selectedOrigen && this.selectedPrimeraVez) {
          this.disabledSend = true;
        } else {
          this.disabledSend = false;
        }
      } else {
        if (this.selectedMessage == 3) {
          this.flagComment = false;
          this.disabledSend = false;
        } else {
          this.flagComment = false;
        }
      }
    },
    selectedMessage: function selectedMessage(val, old) {
      if (val) {
        this.flagTypeMessage = true;
        if ((this.flagComment || val != 3) && this.selectedNacionalidad && this.selectedOrigen && this.selectedPrimeraVez) {
          this.disabledSend = true;
        } else {
          this.disabledSend = false;
        }
      } else {
        this.flagTypeMessage = false;
        this.disabledSend = false;
      }
    },
    selectedOrigenOther: function selectedOrigenOther(val, old) {
      if (val == '') {
        if (this.selectedOrigenRadio != '') {
          this.selectedOrigen = this.selectedOrigenRadio;
        } else {
          this.selectedOrigen = '';
        }
      } else {
        if (this.options_origen.includes(val)) {
          this.selectedOrigenRadio = val;
          this.selectedOrigen = val;
          this.selectedOrigenOther = '';
        } else {
          this.selectedOrigenRadio = '';
          this.selectedOrigen = val;
        }
      }
    },
    selectedOrigenRadio: function selectedOrigenRadio(val, old) {
      if (val != '') {
        this.selectedOrigen = val;
        this.selectedOrigenOther = '';
      }
    },
    fecha_de_cumpleanos: function fecha_de_cumpleanos(val, old) {
      if (val) {
        if (this.date_regex.test(val)) {
          this.flagCumpleanos = true;
          this.disabledSubmit = true;
        } else {
          this.flagCumpleanos = false;
          this.disabledSubmit = false;
        }
      } else {
        this.flagCumpleanos = true;
        this.disabledSubmit = true;
      }
    }
  },
  created: function created() {
    this.fetchLocal();
  },

  methods: {
    reloadOpinion: function reloadOpinion() {
      location.reload();
    },
    continueToOpinion: function continueToOpinion() {
      tempDatos = [this.pickedRestaurant, this.pickedLocal];
      for (i in tempDatos) {
        if (!tempDatos[i]) {
          return this.modalError = !this.modalError;
        }
      }
      return this.infoSubmitted = !this.infoSubmitted;
    },
    continueToDatos: function continueToDatos() {
      return this.encuestaSubmitted = !this.encuestaSubmitted;
    },
    getLocalsForSelect: function getLocalsForSelect() {
      if (this.pickedRestaurant == null) {
        return [];
      } else {
        return this.locals[this.pickedRestaurant - 1];
      }
    },
    pickRestaurant: function pickRestaurant(n) {
      if (this.pickedRestaurant == null) {
        document.getElementById('logo' + n).style.border = "3px solid rgba(52,168,235,1)";
        this.pickedRestaurant = n + 1;
        this.restaurantPicked = true;
      } else {
        document.getElementById('logo' + (this.pickedRestaurant - 1)).style.border = "";
        document.getElementById('logo' + n).style.border = "3px solid rgba(52,168,235,1)";
        this.pickedRestaurant = n + 1;
      }
      this.pickedLocal = null;
      this.selectableLocals = [];
      for (var i in this.locals) {
        if (this.locals[i].r_id == this.pickedRestaurant) {
          this.selectableLocals.push(this.locals[i]);
        }
      }
      if (this.pickedRestaurant == 1) {
        this.options_origen = [{ value: 'Recomendación', text: 'Recomendación (Recommendation)' }, { value: 'Redes Sociales', text: 'Redes Sociales (Social Networks)' }, { value: 'Publicidad en el Centro Comercial', text: 'Publicidad en el Centro Comercial (Mall publicity)' }];
      } else if (this.pickedRestaurant == 2) {
        this.options_origen = [{ value: 'Recomendación', text: 'Recomendación (Recommendation)' }, { value: 'Redes Sociales', text: 'Redes Sociales (Social Networks)' }, { value: 'Publicidad Impresa', text: 'Publicidad Impresa (Printed Ads)' }];
      } else if (this.pickedRestaurant == 3) {
        this.options_origen = [{ value: 'Recomendación', text: 'Recomendación (Recommendation)' }, { value: 'Redes Sociales', text: 'Redes Sociales (Social Networks)' }, { value: 'Medios Escritos', text: 'Medios Escritos (Written Media)' }];
      } else if (this.pickedRestaurant == 4) {
        this.options_origen = [{ value: 'Recomendación', text: 'Recomendación (Recommendation)' }, { value: 'Redes Sociales', text: 'Redes Sociales (Social Networks)' }, { value: 'Medios Escritos', text: 'Medios Escritos (Written Media)' }];
      }
    },
    scoreStyle: function scoreStyle(_flag, _opt) {
      if (!this['flag' + _flag]['opt' + _opt]) {
        if (_opt === 1) {
          return "border-width: 1px 0px 1px 1px;";
        } else if (_opt === 10) {
          return "border-width: 1px 1px 1px 0px;";
        } else {
          return "";
        }
      } else {
        return "border-width: 0px; color: white !important;";
      }
    },
    scoreColor: function scoreColor(_flag, _opt) {
      if (this['flag' + _flag]['opt' + _opt]) {
        return "success";
      } else {
        return "default";
      }
    },
    submitClient: function submitClient() {
      var _this = this;

      if (!this.ignoreSubmit) {
        this.ignoreSubmit = true;
        var data = {
          sabor: this.itemSelected[0],
          variedad_de_carta: this.itemSelected[1],
          servicio: this.itemSelected[2],
          rapidez: this.itemSelected[3],
          ambiente: this.itemSelected[4],
          recomendacion: this.itemSelected[5],
          nacionalidad: this.selectedNacionalidad,
          primera_vez: this.selectedPrimeraVez,
          origen_de_interes: this.selectedOrigen,
          firstname: this.first_name,
          lastname: this.last_name,
          email: this.email,
          phone_number: this.phone_number,
          distrito: this.distrito,
          fecha_de_cumpleanos: this.fecha_de_cumpleanos,
          local_id: this.pickedLocal.value,
          restaurante_id: this.pickedRestaurant,
          type: this.selectedMessage,
          body: this.comment
        };
        this.$http.post('/opinion', data).then(function (response) {
          setTimeout(function () {
            _this.clearOptions();
            _this.modalFinish = true;
          }, 1000);
        }, function (response) {
          if (response.status === 401 || response.status === 403) {
            window.localStorage.removeItem('restaurante');
            window.localStorage.removeItem('local');
            window.localStorage.removeItem('role');
            window.localStorage.removeItem('uid');
            _this.$router.go({
              name: 'client'
            });
          }
        });
      }
    },
    activeFlag: function activeFlag(_flag, _opt) {
      this['flag' + _flag]['opt' + _opt] = true;
      for (var i = 1; i < 6; i++) {
        if (i !== _opt) {
          this['flag' + _flag]['opt' + i] = false;
        }
      }
      this.itemSelected[_flag - 1] = _opt;
      if ((this.flagTypeMessage && (this.flagComment || this.selectedMessage != 3) || !this.flagTypeMessage && !this.flagComment) && this.selectedPrimeraVez && this.selectedNacionalidad && this.selectedOrigen) {
        this.disabledSend = true;
      }
    },
    activeFlagScore: function activeFlagScore(_flag, _opt) {
      this['flag' + _flag]['opt' + _opt] = true;
      for (var i = 1; i < 11; i++) {
        if (i !== _opt) {
          this['flag' + _flag]['opt' + i] = false;
        }
      }
      this.itemSelected[_flag - 1] = _opt;
      if ((this.flagTypeMessage && (this.flagComment || this.selectedMessage != 3) || !this.flagTypeMessage && !this.flagComment) && this.selectedPrimeraVez && this.selectedNacionalidad && this.selectedOrigen) {
        this.disabledSend = true;
      }
    },
    clearOptions: function clearOptions() {
      for (var i = 1; i < 6; i++) {
        for (var j = 1; j < 6; j++) {
          this['flag' + i]['opt' + j] = false;
        }
      }
      for (var k = 1; k < 11; k++) {
        this.flag6['opt' + k] = false;
      }
      this.comment = '';
      this.selectedMessage = null;
      this.disabledSend = false;
    },
    fetchLocal: function fetchLocal() {
      var _this2 = this;

      var _url = '/admin/local';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this2.locals.push({
            text: val.name,
            value: val.id + '',
            r_id: val.restaurante_id
          });
        });
        // let _data = response.data
        _this2.$nextTick(function () {
          _this2.responseUsers = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this2.person = response.data;
          _this2.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <section class=\"section-client\">\n    <div v-if=\"!infoSubmitted\" class=\"container-client clearfix\">\n      <div class=\"text-center\" style=\"margin-bottom: 25px\">\n        <img src=\"/assets/img/logo0.png\" alt=\"logo\" style=\"margin-bottom: 20px; width: 50%; max-width: 50%\">\n        <p class=\"spanish_text\" style=\"font-size: 28px\">Elige tu restaurante</p>\n        <p>(Choose your restaurant)</p>\n        <div v-for=\"n in 4\" class=\"logo-group-div\" @click=\"pickRestaurant(n)\" id=\"logo{{n}}\">\n          <img class=\"logo-group\" :src=\"'/assets/img/logo' + (n+1) + '.png'\" alt=\"logo\">\n        </div>\n      </div>\n      <div v-show=\"restaurantPicked\">\n        <ui-select name=\"level\" class=\"inputFull\" label=\"Local:\" :options=\"selectableLocals\" :value.sync=\"pickedLocal\"></ui-select>\n        <div class=\"text-center\" style=\"margin-bottom: 25px\">\n          <ui-button color=\"lanacional-cuarto\" text=\"Continuar\" @click=\"continueToOpinion()\"></ui-button>\n        </div>\n      </div>\n    </div>\n\n    <div v-if=\"!encuestaSubmitted &amp;&amp; infoSubmitted\" class=\"container-client clearfix\">\n      <div class=\"text-center\">\n        <img class=\"logo\" :src=\"'/assets/img/logo' + (pickedRestaurant) + '.png'\" alt=\"logo\">\n      </div>\n      <div class=\"list_menu\">\n        <ui-radio-group :options=\"options_nacionalidad\" label=\"Nacionalidad (Nationality)\" :value.sync=\"selectedNacionalidad\" name=\"nacionalidad\"></ui-radio-group>\n        <p class=\"question_spanish\" style=\"margin-top: 15px; margin-bottom: 0px; text-align: center; color: black\">Por favor, califica lo siguiente:</p>\n        <p style=\"margin-bottom: 0px; text-align: center; color: black\">Please rate the following:</p>\n        <div class=\"item_menu\">\n          <div class=\"head_item\">\n            <p class=\"item_label spanish_text\">Sabor<br><span class=\"english_label\">Food</span></p>\n          </div>\n          <div class=\"body_item\">\n            <ul class=\"nav nav_face\">\n              <li v-for=\"n in 4\" :class=\"['face' + (n+1), {'active': flag1['opt'+(n+1)]}]\" @click=\"activeFlag(1,(n+1))\"></li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"item_menu\">\n          <div class=\"head_item\">\n            <p class=\"item_label spanish_text\">Variedad&nbsp;de&nbsp;Carta<br><span class=\"english_label\">Menu&nbsp;Variety</span></p>\n          </div>\n          <div class=\"body_item\">\n            <ul class=\"nav nav_face\">\n              <li v-for=\"n in 4\" :class=\"['face' + (n+1), {'active': flag2['opt'+(n+1)]}]\" @click=\"activeFlag(2,(n+1))\"></li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"item_menu\">\n          <div class=\"head_item\">\n            <p class=\"item_label spanish_text\">Servicio<br><span class=\"english_label\">Service</span></p>\n          </div>\n          <div class=\"body_item\">\n            <ul class=\"nav nav_face\">\n              <li v-for=\"n in 4\" :class=\"['face' + (n+1), {'active': flag3['opt'+(n+1)]}]\" @click=\"activeFlag(3,(n+1))\"></li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"item_menu\">\n          <div class=\"head_item\">\n            <p class=\"item_label spanish_text\">Rapidez<br><span class=\"english_label\">Speed&nbsp;of&nbsp;service</span></p>\n          </div>\n          <div class=\"body_item\">\n            <ul class=\"nav nav_face\">\n              <li v-for=\"n in 4\" :class=\"['face' + (n+1), {'active': flag4['opt'+(n+1)]}]\" @click=\"activeFlag(4,(n+1))\"></li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"item_menu\">\n          <div class=\"head_item\">\n            <p class=\"item_label spanish_text\">Ambiente<br><span class=\"english_label\">Environment</span></p>\n          </div>\n          <div class=\"body_item\">\n            <ul class=\"nav nav_face\">\n              <li v-for=\"n in 4\" :class=\"['face' + (n+1), {'active': flag5['opt'+(n+1)]}]\" @click=\"activeFlag(5,(n+1))\"></li>\n            </ul>\n          </div>\n        </div>\n        <p class=\"question_spanish\" style=\"margin-top: 15px; margin-bottom: 0px; text-align: center; color: black\">Del 1 al 10, ¿qué tan probable es que nos recomiendes en el futuro?</p>\n        <p style=\"margin-bottom: 0px; text-align: center; color: black\">In a scale from 1 to 10, how likely is it that you would recommend us in the future?</p>\n        <div class=\"item_menu\" style=\"padding-left: 0px;\">\n          <div class=\"body_item\">\n            <ui-button v-for=\"n in 10\" class=\"score-item\" :raised=\"!flag6['opt1'+(n+1)]\" @click=\"activeFlagScore(6,(n+1))\" :color=\"scoreColor(6,(n+1))\" :style=\"scoreStyle(6,(n+1))\">{{n+1}}</ui-button>\n          </div>\n        </div>\n        <p class=\"question_spanish\" style=\"margin-top: 15px; margin-bottom: 0px; text-align: center; color: black\">¿Es la primera vez que nos visitas?</p>\n        <p style=\"text-align: center; color: black\">Is this the first time you visit us?</p>\n        <ui-radio-group :options=\"options_primera_vez\" :value.sync=\"selectedPrimeraVez\" name=\"primera_vez\"></ui-radio-group>\n        <p class=\"question_spanish\" style=\"margin-top: 15px; margin-bottom: 0px; text-align: center; color: black\">¿Cómo te enteraste?</p>\n        <p style=\"text-align: center; color: black; margin-bottom: 40px;\">How did you find out about us?</p>\n        <ui-radio-group :options=\"options_origen\" :value.sync=\"selectedOrigenRadio\" name=\"origen\"></ui-radio-group>\n        <ui-textbox label=\"Otro (Other):\" style=\"margin-top: 25px\" name=\"origen\" type=\"text\" :value.sync=\"selectedOrigenOther\" autocomplete=\"off\"></ui-textbox>\n        <p class=\"question_spanish\" style=\"margin-top: 15px; margin-bottom: 0px; text-align: center; color: black\">Si deseas, puedes dejar un comentario adicional a continuación.</p>\n        <p style=\"text-align: center; color: black;\">If you wish, you can leave an additional comment below</p>\n        <ui-radio-group :options=\"options_comentario\" label=\"Comentario (Comment)\" :value.sync=\"selectedMessage\" name=\"comment\"></ui-radio-group>\n        <div class=\"item_menu\" style=\"padding-left:0px\">\n          <div class=\"body_item\">\n            <ui-textbox name=\"comment\" type=\"text\" :value.sync=\"comment\" :multi-line=\"true\" autocomplete=\"off\"></ui-textbox>\n          </div>\n          <br>\n          <div class=\"text-center\" style=\"margin-bottom: 25px\">\n           <ui-button color=\"lanacional-cuarto\" text=\"Continuar\" @click=\"continueToDatos()\" :disabled=\"!disabledSend\"></ui-button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div v-if=\"encuestaSubmitted &amp;&amp; infoSubmitted\" class=\"container-client clearfix\">\n      <div class=\"text-center\">\n        <img class=\"logo\" :src=\"'/assets/img/logo' + (pickedRestaurant) + '.png'\" alt=\"logo\">\n      </div>\n      <p class=\"question_english\" style=\"margin-top: 25px; margin-bottom: 0px; text-align: center; color: black\"><span style=\"font-weight: bold; font-size: 24px\">Por favor, ingresa tus datos:</span><br>(Esta sección es completamente opcional)</p>\n      <p style=\"margin-bottom: 25px; text-align: center; color: black\">Please submit the following information:<br>(This step is completely optional)</p>\n      <ui-textbox class=\"inputHalf\" type=\"text\" name=\"first_name\" label=\"Nombre (First Name)\" :value.sync=\"first_name\" autocomplete=\"off\"></ui-textbox>\n      <ui-textbox class=\"inputHalf\" type=\"text\" name=\"last_name\" label=\"Apellido (Last Name)\" :value.sync=\"last_name\" autocomplete=\"off\"></ui-textbox>\n      <ui-textbox class=\"inputHalf\" type=\"email\" name=\"email\" label=\"Correo (Email)\" :value.sync=\"email\" validation-rules=\"required|email\" autocomplete=\"off\"></ui-textbox>\n      <ui-textbox class=\"inputHalf\" style=\"margin-bottom: 40px\" type=\"text\" name=\"phone_number\" label=\"Teléfono (Phone Number)\" :value.sync=\"phone_number\" autocomplete=\"off\"></ui-textbox>\n      <ui-textbox class=\"inputHalf\" type=\"text\" name=\"distrito\" label=\"Distrito (District)\" :value.sync=\"distrito\" autocomplete=\"off\"></ui-textbox>\n      <ui-textbox class=\"inputHalf\" type=\"text\" placeholder=\"dd/mm/aaaa\" name=\"fecha_de_cumpleanos\" label=\"Fecha de Cumpleaños (Birthday)\" :value.sync=\"fecha_de_cumpleanos\" autocomplete=\"off\"></ui-textbox>\n      <div class=\"text-center\" style=\"margin-bottom: 25px\">\n        <ui-button color=\"lanacional-cuarto\" text=\"Enviar\" @click=\"submitClient()\" :disabled=\"!disabledSubmit\"></ui-button>\n      </div>\n    </div>\n  </section>\n\n  <div class=\"modal-mask modal-client\" v-if=\"modalError\" transition=\"modal\">\n    <div class=\"modal-wrapper\">\n      <div class=\"modal-container\">\n        <div class=\"modal-body\">\n          <div class=\"text-center\">\n            <p class=\"message\" style=\"margin: 0;\">Debes ingresar todos los datos para continuar a la encuesta.</p>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <ui-button @click=\"modalError=!modalError\" text=\"OK\" color=\"lanacional-primario\"></ui-button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-mask modal-client\" v-if=\"modalFinish\" transition=\"modal\">\n    <div class=\"modal-wrapper\">\n      <div class=\"modal-container\">\n        <div class=\"modal-body\">\n          <div class=\"text-center\">\n            <p class=\"message\" style=\"margin: 0;\">¡Gracias por brindarnos tu opinión!</p>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <ui-button @click=\"reloadOpinion()\" text=\"OK\" color=\"lanacional-primario\"></ui-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n:-ms-input-placeholder{\n  color: #aaaaaa;\n}\n::placeholder{\n  color: #aaaaaa;\n}\n.spanish_text{\n  margin-bottom: 0px;\n}\n\n.english_label{\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.question_spanish{\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.logo-group{\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  position: relative;\n  margin: auto;\n}\n.score-item{\n  float: left;\n  color: black !important;\n  min-width: 0px;\n  max-width: 10%;\n  border: 1px solid black;\n  border-width: 1px 0px 1px 0px;\n}\n.logo-group-div{\n  width: 33.33%;\n  max-width: 33.33%;\n  margin: 0 auto;\n  vertical-align: middle;\n}\n.logo-group-div:hover{\n  border: 2px solid rgba(52,168,235,.5)\n}\n.inputHalf{\n  width: 50%;\n  max-width: 50%;\n  float: left;\n  padding: 5px 10px;\n}\n.inputFull{\n  width: 100%;\n  max-width: 100%;\n  float: left;\n  padding: 5px 10px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4ad985c7", module.exports)
  } else {
    hotAPI.update("_v-4ad985c7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}